export default {
	'amountForAuthor': "Paiement à l'auteur",
	'addNewamountForAuthor': "Ajouter un paiement à l'auteur",
	'paymentIsFixed': 'Le paiement est fixe',
	'calculateSalary': 'Calculer le salaire',
	'managerType': 'Classe',
	'orderOnlyPremium': 'Commandes premium',
	'saveCardStages': "Enregistrer l'étape",
	'channels': 'Chaînes',
	'isExpired': 'expiré',
	'noManager': "Aucun responsable n'a été affecté",
	'selectResponsible': 'Préciser le responsable',
	'areaResponsibility': 'Domaine de responsabilité',
	'responsible': 'Responsable',
	'generalPriceListForAuthors': 'Paramètres généraux de prix pour les sites Web',
	'specialPriceForAuthors': 'Prix ​​spécial pour les auteurs',
	'whatsappNameChannel': 'Canal',
	'whatsappFirstReadMess': 'Lire',
	'whatsappFirstSentMess': 'Envoyé',
	'yesterdayDay': 'hier',
	'nameWhatsappChannel': 'Canal',
	'messageWhatsappLastText': 'Dernier message',
	'messageText': 'Message',
	"txtInChatReplyTo": 'En réponse à',
	"replyTo": 'Répondre',
	"thereAreUnfilledFields": "Vous devez remplir correctement tous les champs avant de sauvegarder !",
	"utmSource": "Source principale",
	"utmMedium": "Type de publicité",
	"utmCampaign": "Campagne n°.",
	"utmTerm": "Phrase clé",
	"chooseAuthor": "Sélectionner l'auteur",
	"noManagerWhatsAppChat": "sans gérant",
	"emaiErrorlList": {
		"EMAIL_ERROR_MAILBOX_NOT_FOUND": "Adresse du destinataire rejetée : boîte aux lettres introuvable",
		"EMAIL_ERROR_UNIDENTIFIED_ERROR": "Une erreur non identifiée s'est produite lors de l'envoi du courrier, contactez le support technique",
		"EMAIL_ERROR_MESSAGE_EXPIRED": "Message expiré : impossible d'être livré dans les 840 minutes",
		"EMAIL_ERROR_STOP_LIST_AMAZON_SES": "L'e-mail n'est pas ouvert, comme l'adresse de la liste d'arrêt d'Amazon SES",
		"EMAIL_ERROR_MAILBOX_FULL": "La lettre n'a pas été livrée - la boîte aux lettres du destinataire est pleine",
		"EMAIL_ERROR_INVALID_DOMAIN": "Le message n'a pas été remis - le domaine du destinataire n'existe pas",
		"EMAIL_ERROR_CLIENT_ABUSE_SPAM": "Le client a bloqué un e-mail du CRM et s'est plaint du spam du CRM",
	},
	'emailSpamList': 'courrier indésirable',
	'presentationPdfNameHref': 'Titre texte du lien pour la présentation',
	'italian': "Italiano",
	'french': "Français",
	// Новые с 27.10.23
	'infoAboutAuthor': "Informations sur l'auteur",
	'emailAliasAuthor': "Alias ​​email de l'auteur",
	'emailAuthor': "Email de l'auteur",
	'fioAuthor' : "Nom de l'auteur",
	'fioAliasAuthor' : "Alias ​​de l'auteur",
	'activeOrderAuthor': "Commandes actives de l'auteur",
	'urlProfileAuthor' : "Profil de l'auteur",
	'whatsappListChats' : "Whatsapp",
	'whatsappDashboard': 'Whatsapp',
	'nameListChatWhatsapp': "Liste de discussion Whatsapp",
	'whatsappChat': "Chat Whatsapp",
	'whatsappChatMissingCall': "Appel manqué",

	'editWithoutNotice': "Modifier sans notifications",
	'editOffWithoutNotice': "Désactiver le mode édition",
	'titleSystemMessage' : "Message système",
  	'partner': "Partenaire",
	'lastMassages': "Correspondance",
	'last50MessagesManager': "Les 50 derniers messages que vous avez envoyés",
	'noLast50MessagesManager': "Aucun message pour l'instant",
	'emailFrontSite': "Email spécifié sur le site",
	'isPartnerWebsite' : "Site Web partenaire",
  	'partners': "Les partenaires",
	'countWebsites': "Nombre de sites Web",
	'siteChatResponseTemplates': "Modèles de discussion",
	'siteChatResponseTemplatesName' : "Nom",
	'siteChatResponseTemplatesTemplate': "Texte de réponse",
	'chatTemplates': "Modèles de discussion",
	'name_ru' : "Nom (Rus)",
	'name_de': "Nom (allemand)",
	'emailPartner': "Connexion partenaire",
	'countWebsitePartner': "Nombre de sites Web",
	'passPartner1': "Nouveau mot de passe pour le partenaire",
	'passPartner2': "Répéter le nouveau mot de passe",
	'partnerCreateAccount': "Heure de création du compte partenaire",
	'partnerFirstName': "Prénom du partenaire",
	'partnerLastName': "Nom de famille du partenaire",
	'partnerWasCreatedSuccessfully': "Le compte du partenaire a été créé avec succès",
	'stageNumberInOrder' : "Livraison",
	'fileNumbering' : "numéro de fichier",
	'paymentStage': "Paiement",
	'checkYesPaymentStage': "Reçu",
	'checkNoPaymentStage': "Non reçu",
  	'files': "Des dossiers",
	'filesAreNotUploaded': "Aucun fichier n'a été téléchargé",
	'AuthorTasks' : "Tâches",
	'currentMilestonesPagesCount' : "Premier",
	'closeOrderWithoutNotice': "Fermeture express",
	'confirmActionWithoutNotice': "Confirmation de la fermeture",
	'youWantСloseOrderWithoutNotice': "Vous êtes sur le point de marquer la commande en cours comme terminée avec succès et de la clôturer sans en informer le client",
	'youSuccessСloseOrderWithoutNotice': "Commande clôturée avec succès sans notification comme terminée",
	'invoiceFooterTitle': "Pied de page de la facture (PDF)",
  	'noTask': "Aucune tâche pour l'instant",
	'MyAuthorsTasks' : "Délais",
	'taskAboutOrder': "Tâches",
	'noOrderTask': "Il n'y a aucune tâche en cours pour la commande",
	'logAboutOrder': "Historique",
	'noOrderComment': "Aucun historique de commandes",
	'typeEvent' : "Événement",
	'systemTypeEvent': "Événement système",
	'needAuthorPutPage': "L'auteur doit soumettre la scène à temps. Pages",
	'logInMenu' : "Journaux",
  	"orderLog": {
		"NewEmailChangeClientNotAnswerToStatusProcessing": "statut \"Aucune réponse\" -> \"Traitement\", email reçu du client",
		"createNewOrderFromEmail": "Commande créée sur la base d'un e-mail",
		"createNewOrderFromSiteForm": "La commande a été créée via un formulaire sur le site",
		"createNewOrderFromCRM": "Commande créée dans CRM",
		"changeStatusOrder": "Modifier le statut de la commande",
		"addNewMilestone": "Ajout d'un nouveau jalon à une commande",
		"deleteMilestone": "Supprimer une étape d'une commande",
		"orderStandartCompletedWithPayout": "Réussite standard d'une commande complétée avec paiements à l'auteur",
		"deleteAuthorFromOrder": "Supprimer un auteur d'une commande",
		"appointManagerInOrder": "Attribuer un nouveau manager à la commande",
		"managerAcceptedOrder": "Le responsable commercial a confirmé la réception de la commande",
		"managerSecondAcceptedOrder": "Le responsable du support a confirmé la réception de la commande",
		"setMarkAsReadChactClient": "Discuter avec un client marqué comme lu",
		"updatingOrderData": "Mise à jour des données de commande",
		"updatingStageData": "Mise à jour des données de l'étape",
		"confirmPaymentMilestone": "La réception de l'argent a été confirmée sur le compte pour le paiement de l'étape",
		"changeOrderStatusToInProgressAndAddAuthor": "-> \"En cours\", nouvel auteur attribué",
		"setFailedOrder": "Commande marquée comme ayant échoué et fermée",
		"setConfirmedOrder": "La commande est marquée comme terminée et clôturée avec succès",
		"setNewPriceJmOrderMilestone": "Un nouveau prix a été attribué aux auteurs juniors et intermédiaires pour la scène. Nouveau tarif : ",
		"setNewPriceSOrderMilestone": "Un nouveau prix a été attribué aux auteurs seniors pour la scène. Nouveau tarif : ",
		"moveOrderToTrash": "La commande a été déplacée vers le panier et fermée",
		"moveEmailToSpamList": "L'EMAIL du client est inclus dans la liste des spams du CRM. Les e-mails du client seront ignorés.",
		"addWorkTypeToOrder": "Un nouveau type de travail a été ajouté à la commande. Pages : ",
		"changeOrderStatusToClientNotAnswer": "-> \"Pas de réponse\"",
		"setCloseOrderWithoutNotice": "La commande est marquée comme terminée avec succès et clôturée sans notification au client",
		"sendOrderForApproval": "La commande a été envoyée au client pour approbation",
		"changeOrderStatusToWaitingPayment": "-> \"En attente de paiement\"",
		"changeOrderStatusToProcessing": "-> \"En cours de traitement\"",
		"changeOrderStatusToWaitingAuthor": "-> \"À la recherche d'un artiste\"",
		"changeOrderStatusToInProgress": "-> \"En cours\"",
		"changeOrderStatusToWaitingApprove": "-> \"Confirmé\"",
		"changeOrderStatusToPatchMode": "-> \"Vers le mode édition\"",
		"autoDistributionOfManagersSuccess": "Attribuer automatiquement un nouveau manager à une commande",
		"autoDistributionOfManagersError": "Impossible d'attribuer automatiquement un nouveau manager",
		'autoDistributionOfManagersToWhatsappSuccess': 'Attribuez automatiquement un nouveau responsable au chat WhatsApp',
		'autoDistributionOfManagersToWhatsAppError': "Échec de l'attribution automatique d'un nouveau responsable au chat WhatsApp",
		"noManagerInDutySchedule": "Il n'y a aucun manager pour l'équipe en cours",
		"dubleOrderIn10Minutes": "Commande double au cours des 10 dernières minutes",
		"noIfInDayDutySchedule": "Il n'y a aucune condition pour sélectionner un manager",
		"noFreeOtherManagerInDayDutySchedule": "Il n'y a aucun manager en service qui n'a pas encore travaillé avec ce client",
		"switchOnlineManager": "Le manager est de nouveau en ligne",
		"switchOfflineManager": "Le manager s'est déconnecté",
		"switchAllowedFollowUpOrder": "Les messages de suivi sont activés pour la commande client",
		"switchNotAllowedFollowUpOrder": "Désactiver les messages de suivi pour une commande client",
		"autoCompletionOrderAfter5Days": "Réalisation automatique de la commande après 5 jours de silence du client",
		'changeNewGeneralManager': "Un nouveau directeur général a été nommé : ",
		'changeOrderStatusToClientNotAnswer': "-> \"Pas de réponse\" ",
		'managerEmailchangeOrderStatusToClientNotAnswer': "après l'e-mail du manager",
		'managerAcceptOrderchangeOrderStatusToClientNotAnswer': "après que le manager ait accepté la commande",
		'managerCreateOrderchangeOrderStatusToClientNotAnswer': "après que le responsable ait créé une commande",
		'authorLeaveOrder': "L'auteur a quitté la commande",
		'authorAcceptOrder': "La commande a été acceptée par l'auteur",
	},
	'dateTimeEvent': "Heure de l'événement",
	'numberOrder': "Numéro de commande",
	"noNextManager": "---",
	"managerDutySchedule": "Horaire des tâches",
	"managerDutyScheduleH1": "Horaire des tâches des managers",
	"managerDutyScheduleNameFirstLine": "1ère ligne",
	"managerDutyScheduleNameSecondLine": "2ème ligne",
	"goBack": "Retourner",
	"selectMultiManagersTitle": "Sélectionner les managers...",
	"doYouWantToDeleteManagerFromDay": "Vous êtes sur le point de supprimer un manager du planning de cette journée",
	"tariffSchedule": "Barème tarifaire",
	"iAmOnline": "Je suis en ligne",
	"iAmOffline": "Hors ligne",
	"changeStatusManagerTitle": "Changer le statut",
	"doYouWantStatusOfflineManager": "Vous vous déconnectez et suspendez l'acceptation des commandes",
	"doYouWantStatusOnlineManager": "Vous êtes de nouveau en ligne et prêt à accepter les commandes",
	"switchOfflineManagerNotification": "Vous êtes hors ligne",
	"switchOnlineManagerNotification": "Vous êtes de nouveau en ligne",
	"onlineStatusManager": "Statut",
  	"online": "En ligne",
	"offline": "Hors ligne",
	"statusFollowUp": "Statut des mailings de suivi",
	"allowedFollowUp": "Suivis autorisés",
	"notAllowedFollowUp": "Les suivis sont désactivés",
	"doYouWantStatusAllowedFollowUpOrder": "Vous autorisez l'envoi de messages de suivi au client",
	"doYouWantStatusNotAllowedFollowUpOrder": "Vous désactivez l'envoi de messages de suivi au client",
	"switchNotAllowedFollowUpOrderNotification": "Vous avez désactivé le message de suivi pour le client",
	"switchAllowedFollowUpOrderNotification": "Vous avez autorisé l'envoi de messages de suivi au client",
	"authorCostPerPageH1": "Coût d'une page pour l'auteur, en euros",
	"allowAuthorPaymentReward": "Confirmez-vous la réalisation de l'étape et le paiement des droits à l'auteur ?",
  	'balance': "Équilibre",
	'topManager': "Principal",
	'changeGeneralManagerTitle': "Changer de directeur général",
	'doYouWantChangeGeneralManager': "Attribuer un nouveau directeur général",
  	'rating': "Notation",
	'newbie': "Débutant",
	'paymentsHistoryOrders': "Accumulations",
	'titleDialogChangeOrderStatus': "Sélectionnez le nouveau statut de la commande...",
	'emailAliasManager' : "Alias ​​de messagerie",
	'sendFromAuthor': "de l'auteur",
	'uploadCompletedStage': "Télécharger une étape terminée.",
  	'modify': "Finaliser",
	'forRevision': "Pour révision",
	'returnToAuthorForRevision': "Retour à l'auteur pour révision...",
	'addCommentForAuthor': "Dites ici à l'auteur ce qui doit être modifié :",
	'changeStatusOrderToPatchModeStage': "Vous avez envoyé avec succès la scène à l'auteur pour révision",
	'waitForConfirmationJobAcceptance': "Attendez la confirmation de l'acceptation du poste.",
	'stagePatchModeNumber' : "Patch",
	'editingModeEnabled': "Le mode édition est activé",
	'acceptJob': "Accepter le travail",
  	// Новые с 27.10.23

	'addTicket': "Ajouter une commande",
	'addTask': "Ajouter une tâche",
	'addOrderComment': "Ajouter un commentaire",
	'noOrderComment': "Il n'y a aucun commentaire sur la commande",
	'unknowUserRole': "Auteur inconnu",
	'unknowUserName': "Inconnu",
	'addOrderCommentSuccess': "Commentaire ajouté avec succès à la commande !",
  	'from': "Depuis",
	'to': "Avant",
	'reset': "Réinitialiser",
	'searchByNameAndClient': "Envoyer un e-mail au client ou à la demande",
	'save': "Sauvegarder",
	'cancel': "Annuler",
	'chooseDate': "Sélectionner une date",
	'description': "Description",
	'taskView': "Description de la tâche",
	'date': "date",
	'ticket': "Commande",
	'setByAdmin': "Important!",
	'delete': "Supprimer",
	'done': "Fait",
	'notDone': "Pas fini",
	'completedSuccessfully': "Terminé avec succès",
	'addedSuccessfully': "Ajouté avec succès",
	'setPriceSuccessfully': "Le prix a été modifié avec succès",
	'changedSuccessfully': "Modifié avec succès",
	'deletedSuccessfully': "Supprimé avec succès",
  	'name': "Nom",
	'subject': "Article",
	'type': "Taper",
	'pagesCount': "Pages",
	'milestonesCount': "Étapes",
	'priceEuro': "Prix, €",
	'dueDate': "Date limite",
	'dueTimeAuthor': "Date limite de l'auteur",
	'manager': "Directeur",
	'comment': "Un commentaire",
	'client': "Client",
	'level': "Niveau",
	'author': "Auteur",
	'task': "Tâches",
	'new': "Nouveau",
	'transmitted': "Transmis",
	'forRemoval': "Pour suppression",
	'clientNotAnswer': "Pas de réponse",
	'processing': "Dans le traitement",
	'waitingPayment': "En attente de paiement",
	'waitingAuthor': "Je recherche un artiste",
	'inProgress' : "En cours",
	'patchMode': "Modifications",
	'waitingApprove' : "Approuver",
  	'completed': "Fait",
	'failedWithPayout': "Échec (frais payés)",
	'failed': "Échoué",
	'createOrder': "Créer une commande",
	'newtonsLaw' : "Loi de Newton",
	'clientsPhone' : "Téléphone client",
	'clientsEmail': "E-mail du client",
	'clientsEmailSecondary': "E-mail du client (supplémentaire)",	
	'site': "Site web",
	'email_host': "Adresse du serveur de courrier entrant",
	'emailIncomingUserName': "Connexion au serveur de messagerie entrant",
	'passIncomingEmail': "Mot de passe du serveur de messagerie entrant",
	'emailPort': "Port du serveur de messagerie entrant",
	'emailSecure': "Protocole du serveur de courrier entrant",
	'emailOutgoingHost': "Adresse du serveur de messagerie sortant",
	'emailOutgoingUserName': "Connexion au serveur de messagerie sortant",
	'emailOutgoingUserPassword': "Mot de passe du serveur de messagerie sortant",
	'emailOutgoingPort': "Port du serveur de messagerie sortant",
	'emailOutgoingSecure': "Protocole du serveur de courrier sortant",
	'subjectArea' : "Sujet",
	'workType' : "Type de travail",
	'qualityLevel' : "Niveau de qualité",
	'pagesAmount': "Nombre de pages",
	'workLanguage': "Langage en cours d'exécution",
  	'language': "Langue",
	'loadFile': "Téléverser un fichier",
	'create': "Créer",
	'orderWasCreatedSuccessfully': "Commande créée avec succès",
	'order': "Commande",
	'currentOrderStatus': "Statut actuel de la commande",
	'price': "Prix",
	'refuseWork': "Refuser la commande",
	'writeMessage': "Écrire un message",
	'chatWithAurhor': "Discuter avec l'auteur",
	'chatWithManager': "Discuter avec le Manager",
	'invitesWasSent': "Les invitations ont été envoyées",
	'youMarkedOrderAs': "Vous avez marqué la commande comme",
	'confirmAction': "Confirmer l'action",
	'checkFullPaymentStage': "Le client a-t-il reçu le montant total ?",
  	'agree': "Démarrer la commande",
	'youWantToMarkOrderAs': "Vous allez marquer la commande comme",
	'totalWorks': "Total des commandes",
	'currentWorks': "Commandes en cours",
	'favorites': "Favoris",
	'invite': "Inviter",
	'performersRequests': "Candidatures des artistes interprètes ou exécutants",
	'select': "Choisir",
	'yourRequestsWasSentSuccessfully': "Vos invitations ont été envoyées avec succès",
	'youHaveAssignedAuthorToThisProject': "Vous avez attribué un auteur à cette commande",
	'thanksWeReceivedYourRequest': "Merci, nous avons bien reçu votre demande",
	'managerWillConfirmItSoon': "Le manager le confirmera bientôt",
	'pleaseWait': "Veuillez patienter",
	'paymentDetails': "Détails du paiement",
  	'stage': "Scène",
	'priceForClient': "Prix ​​pour le client",
	'priceForJuniorAndMiddle': "Prix pour Junior et Moyen",
	'newPriceForJuniorAndMiddle': "Nouveau prix pour Junior et Middle",
	'priceForSenior': "Prix pour Senior",
	'newPriceForSenior': "Nouveau prix pour Senior",
	'pagesAmountShort': "Nombre de pages",
	'loadPhoto': "Charger la photo",
	'downloadChecks': "Télécharger les chèques",
	'confirmPayment': "Confirmer le paiement",
	'recommendedPaymentSum': "Montant du paiement recommandé",
	'totalPaymentSum': "Montant total du paiement",
	'lowerThanRecommendedSum': "Le montant est inférieur à celui recommandé",
	'addStage': "Ajouter une étape",
	'sendForApproval': "Envoyer pour approbation",
  	'edit': "Modifier",
	'approve': "Approuver",
	'firstlyAddWorkTypeToOrder': "Sélectionnez un type de travail",
	'youdownloadChecksSuccessfully': "Vous avez téléchargé avec succès les chèques",
	'youConfirmedPaymentSuccessfully': "Vous avez confirmé le paiement avec succès",
	'dataWasSentToClientForApproval': "Fichiers envoyés au client",
	'dataWasSentForApproval': "Document envoyé pour approbation",
	'youMarkedStageAs': "Vous avez marqué la scène comme",
	'stageWasMovedToStatus': "Modification du statut de la commande :",
	'payRewardToAuthor': "Payer les redevances de l'auteur",
	'authorsReward': "Montant des redevances",
	'pay': "Payer",
	'doCancel': "Annuler",
	'indicateFailureReason': "Indiquez la raison de l'échec",
	'informationAboutOrder': "Informations",
	'editInformationAboutOrder': "Modifier",
	'commentAboutOrder': "Commentaires",
	'workName' : "Sujet",
	'clientsComment': "Commentaire client",
	'recommendedSumShort': "Somme recommandée",
  	'add': "Ajouter",
	'attachedFiles': "Fichiers joints | Fichier joint | Fichiers joints | Fichiers joints",
	'paymentMethod': "Mode de paiement",
	'filesFromAuthor': "Fichiers de l'auteur",
  	'send': "Envoyer",
	'sendAutomatically': "Envoyer automatiquement",
	'filesWasSentToClient': "Les fichiers ont été envoyés au client",
  	'refuse': "Refuser",
	'youWantToCompleteOrder': "Vous êtes sur le point de finaliser la commande",
	'thisActionIsIrreversible': "Cette action est irréversible",
	'completeOrder': "Commande complète",
	'orderIsCompletedSuccessfully': "Commande terminée avec succès",
	'writeToManager': "Écrire au manager",
  	'discuss': "Discuté",
	'creationDate': "Date de création",
	'calculatedSum' : "Prix calculé",
	'incluantTVA' : "incluant TVA",
  	'assign': "Attribuer",
	'chooseManager': "Choisir un manager",
	'passwordRecovery': "Récupération de mot de passe",
	'enterYourEmailAndWeWillSendYouNewPassword': "Entrez votre email et nous vous enverrons un nouveau mot de passe",
	'recoverPassword' : "Récupérer le mot de passe",
	'toLoginPage': "Vers la page de connexion",
	'newPasswordIsGeneratedAndSentToMail': "Le nouveau mot de passe a été envoyé par email",
  	'registration': "Inscription",
	'fillFormBelowToCreateNewAccount': "Remplissez le formulaire ci-dessous pour créer un nouveau compte",
	'youAreAlreadyLoggedIn': "Vous êtes déjà connecté !",
  	'entrance': "Entrée",
	'welcomeBack': "Content de te revoir",
	'pleaseLoginToYourAccount': "Veuillez vous connecter à votre compte",
	'password': "Mot de passe",
	'repeatPassword': "Répéter le mot de passe",
	'newPassword': "Nouveau mot de passe",
  	'yes': "Oui",
	'no': "Non",
	'confirmDeletion': "Confirmer la suppression",
	'doYouWantToDelete': "Vous êtes sur le point de supprimer",
	'registrationLinkCreation': "Création d'un lien d'inscription",
	'linkToRegistrationForm': "Lien vers le formulaire d'inscription",
  	'generate': "Générer",
	'close': "Fermer",
	'nickname': "Surnom",
	'emailForPayment': "IBAN SEPA / Transferwise-Email",
	'phone': "Téléphone",
	'sex': "Sol",
	'country': "Un pays",
	'birthDate': "Date de naissance",
	'surname': "Nom de famille",
	'profile': "Profil",
	'subjects': "Articles",
	'aboutYourself': "Sur moi",
	'dataIsSaved': "Données enregistrées",
	'totalOrdersCount': "Nombre total de commandes",
	'success': "Succès",
	'personName': "Nom",
	'otherCustomerProfiles': "Autres profils",
	'changeWorkType': "Changer le type de travail",
	'shortRussian': "russe",
	'shortGerman': "lui",
	'totalTicketsAmount': "Nombre total de commandes",
	'activatedTickets': "Commandes actives",
	'income': "Revenu",
	'totalIncome' : "Revenu total",
	'clientEditing': "Édition client",
	'additionalEmail': "E-mail supplémentaire",
	'activatedOrder': "Commandes actives",
	'changingManagerRequest': "Demande de changement de manager",
	'newManager' : "Nouveau gestionnaire",
  	'confirm': "Confirmer",
	'decline': "Rejeter",
	'firstlySelectManager': "Vous devez d'abord sélectionner un manager",
	'changingManagerRequestIsSent': "Une demande de changement de manager a été envoyée",
	'requestWasDeclined': "La demande a été annulée",
	'searchByName': "Rechercher par nom",
  	'actions': "Actions",
	'totalOrders': "Total des commandes",
	'paidOrder': "Payé",
	'hangingOrders': "Suspendu",
	'sitesPreferences' : "Préférences du site",
	'managerEditing': "Modification du gestionnaire",
	'managerCreating': "Création d'un manager",
	'sitesSettings' : "Paramètres du site",
	'basicPrices' : "Prix de base",
	'workTypesVisibility': "Visibilité du type de travail",
	'invoicesData': "Données pour les factures",
	'siteAutoEmailAnswer': "Réponses automatiques",
	'siteAutoEmailName' : "Événement",
	'siteAutoEmailDialogTitile': "Modifier la réponse automatique du site",
	'siteChatResponseDialogTitile': "Modifier le modèle de discussion du site",
	'siteAutoEmailTemplate': "Texte de l'e-mail",
	'siteAutoEmailLetterSubject': "Objet de la lettre (jusqu'à 255 caractères)",
	'siteAutoEmailTemplateSuccess': "Le texte de réponse du site a été mis à jour !",
	'siteAutoEmailParameter': "Paramètres possibles pour la substitution",
	'changesIsSavedSuccessfully': "Modifications enregistrées avec succès",
	'siteWasCreatedSuccessfully': "Le site a été créé avec succès",
	'managersFee': "Honoraires du directeur des ventes, % de la commande",
	'managersFeeSecond': "Frais du responsable du support, % de la commande",
	'managersGeneralFee': "Honoraires du directeur général, % de la commande",
	'deleteLogo': "Supprimer le logo",
	'firmInfo': "Informations sur l'entreprise",
	'termsAndConditions': "Conditions générales",
  	'part': "Partie",
	'addPresentationPdf': "Ajout d'une présentation pour le site",
	'deletePresentationPdf': "Supprimer la présentation",
	'changePresentationPdf': "Modifier la présentation",
	'changeLogo': "Changer le logo",
	'mainColor': "Couleur principale",
	'additionalColor': "Couleur supplémentaire",
	'highlightingText': 'Couleur du texte du titre du site Web dans CRM',
	'highlightingBackground': "Couleur d'arrière-plan du texte du titre du site dans CRM",
	'showForJunior': "Spectacle pour Junior",
	'showForMiddle' : "Afficher pour le milieu",
	'showForSenior': "Spectacle pour seniors",
  	'general': "Général",
	'bySites': "Par site",
	'openDiscuss': "Ouvrir une demande",
	'opened': "Ouvrir",
	'number': "Nombre",
	'discussTheme': "Objet du recours",
	'status': "Statut",
	'lastAnswer': "Dernière réponse",
	'answerReceived': "Réponse reçue",
	'waitingToAnswer': "En attente d'une réponse",
  	'closed': "Fermé",
	'isClosed': "Fermé",
	'openNewDiscuss': "Ouvrir une nouvelle discussion",
	'discussText': "Texte de l'appel",
	'doYouWantToCloseDiscuss': "Vous êtes sur le point de clôturer le problème",
	'closeDiscuss': "Fermer la discussion",
	'aDiscuss' : "Appel",
	'discussStatus': "Discuter du statut",
  	'write': "Écrire",
	'techSupport': "Soutien technique",
	'pendingConsideration': "En attendant l'examen",
	'paidOut': "Payé",
	'rejected': "Rejeté",
	'payRequest': "Retrait de fonds",
	'writeHowMuchYouWantToWithdraw': "Indiquez le montant que vous souhaitez retirer",
	'rejectPayment': "Rejeter le paiement",
	'paymentRejectingReason': "Raison du rejet du paiement",
	'currentBalance' : "Solde actuel",
  	'withdraw': "Retirer",
	'rejectSuccessfully': "Rejeté avec succès",
	'idTransaction': "identifiant de transaction",
	'sum': "Somme",
	'paymentSystem': "Système de paiement",
	'paymentRequests': "Demandes de paiement",
	'paymentsHistory': "Historique de paiement",
	'user': "Utilisateur",
	'rejectedPayments': "Paiements rejetés",
	'addWorkType': "Ajouter un type de travail",
	'responseText': "Texte de réponse",
	'addAnswer': "Ajouter une réponse",
	'ago': "dos",
	'month(1)': "mois",
	'month(2-5)': "mois",
	'month(6-0': "mois",
	'more': "Plus",
	'lessThanMonth': "Moins d'un mois",
	'markAllAsRead': "tout marquer comme lu",
	'orders': "Ordres",
	'techSupportShort': "Ceux. soutien",
	'exchangePageName': "Échange",
	'tickets': "Ordres",
	'statistics': "Statistiques",
	'finances': "Finance",
	'tasks': "Tâches",
	'clients': "Clientèle",
	'managers': "Gestionnaires",
	'authors': "Auteurs",
	'sites': "Sites Internet",
	'workTypes': "Types de travail",
	'templateAnswers': "Modèle de réponses",
	'scheduledTasks': "Tâches",
	'all': "Tous",
	'notDone(many)': "Актуальные",
	'notRelevant': "Pas pertinent",
	'changeStatusTaskTitle': "Modification du statut d'une tâche",
	'doYouWantStatusTaskNotRelevant': "Marquer la tâche comme non pertinente ?",
	'switchStatusTaskNotRelevantNotification': "Vous avez marqué la tâche comme non pertinente",
	'doYouWantDeleteTask': "Supprimer la tâche ?",
	'deleteTaskNotification': "Vous avez supprimé la tâche",
	'doYouWantCompletedTask': "Terminer la tâche ?",
	'completedTaskNotification': "Vous avez marqué la tâche terminée",
	'sort': "Tri",
	'tasksCalendar': "Calendrier des tâches",
	'languages': "Langues",
	'accessDenied': "L'accès est refusé",
	'addPhoto': "Ajouter une photo",
	'male': "Homme",
	'female': "Femme",
	'searchByOrderName': "Rechercher par nom",
	'addOrder': "Ajouter une commande",
	'doYouWantToRejectOrder': "Vous êtes sur le point d'annuler la commande",
	'yourPersonalManager': "Votre gestionnaire personnel",
	'requestAnotherManager': "Demander un autre manager",
	'writeReason': "Décrivez la raison",
	'profileEditing': "Modification de votre profil",
	'changePhoto': "Changer la photo",
	'deletePhoto': "Supprimer la photo",
	'chatWithYourManager(p1)': "Discutez avec votre",
	'chatWithYourManager(p2)' : "Gestionnaire",
	'chatByOrder': "Discuter par commande",
	'chatAuthorByOrder': "Chattez avec l'auteur par ordre",
	'chatWithManagerByOrder': "Discuter avec le gestionnaire de commandes",
  	'search': "Recherche",
	'copywriter': "Auteur",
	'admin': "Administrateur",
	'successNotification': "Avec succès",
	'dangerNotification': "Attention",
	'errorNotification': "Erreur",
	'fieldFilledIncorrect': "Le champ est mal renseigné",
	"trash": "Panier",
	"titleDialogMoveTrash": "Déplacer la commande vers...",

	// --------------- Чат
	'chatTrackingOpensTimes': "Horaires d'ouverture",
	'chatTrackingLastOpened': "Dernière ouverture",

	// --------------- Заказ
	'orderFailedFeeNotPaid': "La commande a échoué - client refusé (frais non payés)",
	'orderFailedFeePartiallyFullyPaid': "La commande a échoué - le client a refusé (frais partiellement/entièrement payés)",
	'clientNotContacting': "La commande a échoué - le client ne répond pas",
  	'spam': "Courrier indésirable",
	'duplicate': "Dupliquer",

	// --------------- V2
	'newMessagesCountDisplay': "Nouveau",
	'logout': "Sortir",
	'russian': "Русский",
	'german': "Deutsch",
	"sunday": "Dimanche",
	"monday": "Lundi",
	"tuesday": "Mardi",
	"wednesday": "Mercredi",
	"thursday": "Jeudi",
	"friday": "Vendredi",
	"saturday": "Samedi",
	"sundayShort": "Dimanche",
	"mondayShort": "Lundi",
	"tuesdayShort": "Mardi",
	"wednesdayShort": "Mercredi",
	"thursdayShort": "Jeudi",
	"fridayShort": "Vendredi",
	"saturdayShort": "Samedi",
	"january": "Janvier",
	"february": "Février",
	"march": "Mars",
	"april": "Avril",
	"may": "Peut",
	"june": "Juin",
	"july": "Juillet",
	"august": "Août",
	"september": "Septembre",
	"october": "Octobre",
	"november": "Novembre",
	"december": "Décembre",
	"januaryGenitive": "Janvier",
	"februaryGenitive": "Février",
	"marchGenitive": "Marthe",
	"aprilGenitive": "Avril",
	"mayGenitive": "Peut",
	"juneGenitive": "Juin",
	"julyGenitive": "Juillet",
	"augustGenitive": "Augusta",
	"septemberGenitive": "Septembre",
	"octoberGenitive": "Octobre",
	"novemberGenitive": "Novembre",
	"decemberGenitive": "Décembre",
	// --------------- end V2

	// --------------- V3
	"newtonsLaw": "la loi de Newton",
	"topic": "Thème",
	"finished": "Complété",
	"stages": "Étapes",
	"confirmUploading": "Téléchargement du téléchargement",
	"fileDeletedSuccessfully": "Fichier supprimé avec succès",
	"fileDeletionError": "Erreur de suppression du fichier sujet",
	"isConfirmingStage": "Etape de fin de l'étape de confirmation",
	"changeTemplateAnswer": "Modifier la réponse du modèle",
  	"pages": "{n} trucs | {n} trucs | {n} trucs | {n} flocon de neige",
	"doYouWantToDeleteAuthorFromOrder": "Vous souhaitez acheter un auteur avec une commande",
	"doYouWantToDeleteFile": "Vous devez vous occuper de ce jour",
	"youDeletedAuthorFromOrder": "Vous êtes l'auteur de cette commande",
	"noDataAvailable": "N'y allons pas",
	"secondsAgo": "il y a 0 secondes | {n} Il y a quelques secondes | {n}Il y a quelques secondes | Il y a {n} secondes",
	"minutesAgo": "il y a 0 minutes | Il y a {n} minutes | Il y a {n} minutes | Il y a {n} minutes",
	"hoursAgo": "il y a 0 heures | Il y a {n} heures | Il y a {n} heures | Il y a {n} heures",
	"daysAgo": "il y a 0 jours | Il y a {n} jours | Il y a {n} jours | Il y a {n} jours",
	"yearsAgo": "il y a 0 ans | {n} Il y a un an | Il y a {n} ans | Il y a {n} ans",
	"justNow": "Maintenant",
	// --------------- end V3

	"placeholderGlovalSearchOrderById": "Ordre de recherche par numéro",
	"resultGlovalSearchOrderById": "Résultat de la recherche de commande par numéro",
	"textNoResultGlovalSearchOrderById": "Le numéro de commande n'a pas été trouvé dans le système",

	"txtBtnManagerGetOrder": "Accepter la commande",
	"titleModalAddNewManager": "Confirmez-vous un manager ?",
	"titleModalManagerGetOrder": "Accepter la commande",
	"promtModalAddNewManager": "Voulez-vous attribuer un nouveau manager ?",
	"promtModalManagerGetOrder": "Vous acceptez la commande",

	"txtBtnChatMarkAsRead": "Marquer comme lu",
	"notifySuccessChatMarkAsRead": "Ce chat a été marqué comme lu !",

	"listTickets": {
		"idOrder": "№",
		"timeOrder": "date",
		"nameOrder": "Nom de la commande",
		"websiteOrder": "Site web",
	},

	"exchange": {
		'id': '№',
		'name': "Sujet",
		'area': "Article",
		'type': "Taper",
		'page': "Pages",
		'stage': "Étapes",
		'price': "Prix",
		'price_junior_middle': "Prix ​​pour Junior/Moyen",
		'price_senior': "Prix ​​pour les seniors",
		'deadline': "Date limite",
		'accept': "Se mettre au travail",
		'decline': "Rejeter",
		'confirmAction': "Confirmer l'action",
		'confirmActionText': "Vous êtes sur le point d'accepter cette commande.",
		'confirmActionTextFalse': "Vous êtes sur le point de refuser l'invitation à cette commande.",
		'confirmPopup': "Confirmer",
		'order': "Commande",
		'countStages': "Nombre d'étapes",
		'nameWork': "Sujet",
		'subject': "Article",
		'typeWork': "Genre de travail",
		'levelQuality': "Niveau de qualité",
		'countPages': "Nombre de pages",
		'attachFile': "Fichiers joints",
		'langWork': "Langue d'exécution",
		'comment': "Un commentaire",
		'getToWork': "Commencer!",
		'filter': "Фильтр",
		'searchToName': "Rechercher par nom",
		'level': "Niveau",
		'off': "Depuis",
		'to': "Avant",
		'reset': "Réinitialiser",
		'inviteDecline': "Invitation refusée",
		'inviteDeclineText': "Vous avez refusé l'invitation avec succès. Vous pourrez toujours soumettre une demande pour cette commande si vous changez d'avis.",
		'inviteAccept': "Invitation acceptée",
		'inviteAcceptText': "Merci, vous pouvez vous mettre au travail.",
		'requestSend': "Candidature envoyée",
		'requestSendText': "Merci, nous avons reçu votre demande. Le gérant le confirmera prochainement. S'il vous plaît, attendez",
		'success': "Avec succès",
		'successText': "Complété avec succès",
		'deleteText': "Supprimé avec succès",
		'acceptText': "Ajouté avec succès",
	},
	"stats": {
		"junior": "Economy",
		"middle": "Business",
		"senior": "Academic",
		"income": "Revenu",
		"total": "Filet",
		"totalIncome": "Revenu",
		"privateIncome": "Revenu personnel",
		"sitesCount": "Des sites",
		"paidOrdersCount": "Payé",
		"waitingOrdersCount": "Suspendu",
		"graphIncome": "Revenu personnel",
		"graphOrders": "Ordres",
		"graphIncomeGlobal": "Revenu",
		"graphOrdersPaid": "Des ordres 'en suspens'",
		"completeOrder": "Complété",
		"successOrder": "Succès",
		"today": "Aujourd'hui",
		"yesterday": "Hier",
		"currentWeek": "Cette semaine",
		"prevWeek": "La semaine dernière",
		"current_month": "Mois en cours",
		"last_month": "Le mois dernier",
		"last_three_month": "3 mois",
		"last_six_month": "Une demi-année",
		"last_year": "Année",
		"all_time": "Pendant tout ce temps",
		"active": "Commandes actives",
		"clientsCount": "Clientèle",
		"authorsCount": "Auteurs",
		"managersCount": "Gestionnaires",
		"incomeTotal": "Brut",
		"incomeClean": "Net",
		"ordersCount": "Total des commandes",
		"graphUsers": "Nouveaux utilisateurs",
		"graphQualityLevels": "Commandes par niveau de qualité",
		"graphSubjects": "Commandes par article",
		"graphAdminIncome": "Taux de profit",
		"newPaidTickets": "Ordres",
		"completedTickets": "Statuts des commandes terminées",
		"conversion": "Conversion",
		"date": "Дата",
		"manager": "Directeur",
		"clients": "Clientèle",
		"authors": "Auteurs",
		"mangers": "Gestionnaires",
		"graph_new": "Nouvelles commandes",
		"paid": "Commandes payantes",
		"completed": "Fait",
		"failed": "Échoué",
	},
};
